import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglecloudComponent } from './simple-icons-googlecloud.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglecloudComponent ],
    exports:      [ SimpleIconsGooglecloudComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglecloudModule {}
